module.exports = __webpack_public_path__ + "static/img/cabinet24_17.ba6ba1e6.gif";